import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import OMTransactionSearchForm from "./OMTransactionSearchForm";
import OMTransactionSearchResult from "./OMTransactionSearchResult";
import { useLocation } from 'react-router-dom';
import '../../common/css/searchPage.css';


const OMTransactionsMain = (props) => {
    const location = useLocation();
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [dataSource, setDataSource] = useState(null);
    var accessToken = props.oidc.user.access_token;
    var permissions = props.ReceiptReducer.rolePermissions;
    const searchData = (resultData) => {
        setDataSource(resultData);
    };
    const searchPanelData = (resultData) => {

        setSearchPanelStatus(resultData);
    };
    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <OMTransactionSearchForm searchData={searchData} searchPanelData={searchPanelData} selectedTab={props.selectedTab} />
                </div>
                {location.pathname === "/om/transaction" && (
                    <div className="search-page-grid-container">
                        <OMTransactionSearchResult
                            data={dataSource}
                            searchPanelStatus={searchPanelStatus}
                            selectedTab={props.selectedTab}
                            initialDisableButton={true}
                            accessToken={accessToken}
                            permissions={permissions}
                        />
                    </div>
                )}
            </div>
        </div>

    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(OMTransactionsMain);